import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ProductionToolProgramLineService extends Service {
	constructor(injector: Injector) {
		super("ProductionToolProgramLine", injector);
	}

	// API
	forProgram(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForProgram/${id}`);
	}

	operatorSign(id: number, userProfileId: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/OperatorSign/${id}`, { userProfileId });
	}

	reorder(productionToolProgramId: number, lineIdsInOrder: number[]) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Reorder`, { lineIdsInOrder, productionToolProgramId });
	}
}
